import React, { useState } from 'react';
import { UserIcon, MailIcon, LockIcon, BellIcon, CheckIcon } from 'lucide-react';
const AccountSettings = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const handleSaveChanges = () => {
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };
  return <div className="w-full" data-id="element-262">
      <div className="mb-6" data-id="element-263">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-264">
          Configuración de cuenta
        </h1>
        <p className="text-gray-600" data-id="element-265">
          Administra tu información personal y preferencias
        </p>
      </div>
      {/* Success Message */}
      {showSuccess && <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-center space-x-2" data-id="element-266">
          <CheckIcon size={20} className="text-green-600" data-id="element-267" />
          <span className="text-green-800" data-id="element-268">Cambios guardados exitosamente</span>
        </div>}
      {/* Two Column Layout for Large Screens */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6" data-id="element-269">
        {/* Left Column */}
        <div className="space-y-6" data-id="element-270">
          {/* Personal Information */}
          <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-271">
            <div className="flex items-center space-x-2 mb-4" data-id="element-272">
              <UserIcon size={20} className="text-gray-600" data-id="element-273" />
              <h2 className="text-lg font-semibold" data-id="element-274">Información personal</h2>
            </div>
            <div className="space-y-4" data-id="element-275">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-276">
                <div data-id="element-277">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-278">
                    Nombre
                  </label>
                  <input type="text" defaultValue="Ana" className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" data-id="element-279" />
                </div>
                <div data-id="element-280">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-281">
                    Apellidos
                  </label>
                  <input type="text" defaultValue="Beltrán" className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" data-id="element-282" />
                </div>
              </div>
              <div data-id="element-283">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-284">
                  Empresa
                </label>
                <input type="text" defaultValue="PYME Solutions" className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" data-id="element-285" />
              </div>
              <div data-id="element-286">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-287">
                  Cargo
                </label>
                <input type="text" defaultValue="Directora Financiera" className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" data-id="element-288" />
              </div>
            </div>
          </div>
          {/* Email Settings */}
          <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-289">
            <div className="flex items-center space-x-2 mb-4" data-id="element-290">
              <MailIcon size={20} className="text-gray-600" data-id="element-291" />
              <h2 className="text-lg font-semibold" data-id="element-292">Correo electrónico</h2>
            </div>
            <div className="space-y-4" data-id="element-293">
              <div data-id="element-294">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-295">
                  Correo electrónico
                </label>
                <input type="email" defaultValue="ana.beltran@pymesolutions.com" className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" data-id="element-296" />
                <p className="text-xs text-gray-500 mt-1" data-id="element-297">
                  Este correo se usa para iniciar sesión y recibir
                  notificaciones
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Right Column */}
        <div className="space-y-6" data-id="element-298">
          {/* Password Settings */}
          <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-299">
            <div className="flex items-center space-x-2 mb-4" data-id="element-300">
              <LockIcon size={20} className="text-gray-600" data-id="element-301" />
              <h2 className="text-lg font-semibold" data-id="element-302">Contraseña</h2>
            </div>
            <div className="space-y-4" data-id="element-303">
              <div data-id="element-304">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-305">
                  Contraseña actual
                </label>
                <input type="password" placeholder="Ingresa tu contraseña actual" className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" data-id="element-306" />
              </div>
              <div data-id="element-307">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-308">
                  Nueva contraseña
                </label>
                <input type="password" placeholder="Mínimo 8 caracteres" className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" data-id="element-309" />
              </div>
              <div data-id="element-310">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-311">
                  Confirmar contraseña
                </label>
                <input type="password" placeholder="Repite la nueva contraseña" className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" data-id="element-312" />
              </div>
              <p className="text-xs text-gray-500" data-id="element-313">
                La contraseña debe tener al menos 8 caracteres e incluir
                mayúsculas, minúsculas y números
              </p>
            </div>
          </div>
          {/* Contact Preferences */}
          <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm" data-id="element-314">
            <div className="flex items-center space-x-2 mb-4" data-id="element-315">
              <BellIcon size={20} className="text-gray-600" data-id="element-316" />
              <h2 className="text-lg font-semibold" data-id="element-317">
                Preferencias de contacto
              </h2>
            </div>
            <div className="space-y-4" data-id="element-318">
              <div data-id="element-319">
                <label className="block text-sm font-medium text-gray-700 mb-3" data-id="element-320">
                  Notificaciones por correo electrónico
                </label>
                <div className="space-y-3" data-id="element-321">
                  <div className="flex items-center" data-id="element-322">
                    <input type="checkbox" id="email-reports" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" defaultChecked data-id="element-323" />
                    <label htmlFor="email-reports" className="ml-2 text-sm text-gray-700" data-id="element-324">
                      Reportes financieros mensuales
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-325">
                    <input type="checkbox" id="email-alerts" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" defaultChecked data-id="element-326" />
                    <label htmlFor="email-alerts" className="ml-2 text-sm text-gray-700" data-id="element-327">
                      Alertas y notificaciones importantes
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-328">
                    <input type="checkbox" id="email-updates" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-329" />
                    <label htmlFor="email-updates" className="ml-2 text-sm text-gray-700" data-id="element-330">
                      Actualizaciones del producto
                    </label>
                  </div>
                  <div className="flex items-center" data-id="element-331">
                    <input type="checkbox" id="email-marketing" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-332" />
                    <label htmlFor="email-marketing" className="ml-2 text-sm text-gray-700" data-id="element-333">
                      Noticias y consejos financieros
                    </label>
                  </div>
                </div>
              </div>
              <div className="pt-4 border-t border-gray-200" data-id="element-334">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-335">
                  Número de teléfono (opcional)
                </label>
                <input type="tel" placeholder="+52 55 1234 5678" className="w-full p-2.5 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all" data-id="element-336" />
                <p className="text-xs text-gray-500 mt-1" data-id="element-337">
                  Para notificaciones críticas por SMS
                </p>
              </div>
              <div className="flex items-center" data-id="element-338">
                <input type="checkbox" id="sms-alerts" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-339" />
                <label htmlFor="sms-alerts" className="ml-2 text-sm text-gray-700" data-id="element-340">
                  Recibir alertas críticas por SMS
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Save Button */}
      <div className="flex justify-end space-x-3" data-id="element-341">
        <button className="px-6 py-2.5 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" data-id="element-342">
          Cancelar
        </button>
        <button onClick={handleSaveChanges} className="px-6 py-2.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" data-id="element-343">
          Guardar cambios
        </button>
      </div>
    </div>;
};
export default AccountSettings;